import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import VideoGallery from '../components/VideoGallery'
import PatreonCTA from '../components/PatreonCTA'
import LoginModal from '../components/LoginModal'
import { AsciiMeshV2 } from '../components/AsciiMeshV2'
import EmailAuthSection from '../components/EmailAuthSection'
import './Home.css'

const Home = () => {
  const { user, loading, login } = useAuth()
  const [showLogin, setShowLogin] = useState(false)
  const navigate = useNavigate()

  // Auto-redirect logged-in users to community
  useEffect(() => {
    if (!loading && user) {
      navigate('/community', { replace: true })
    }
  }, [user, loading, navigate])

  const handleLoginSuccess = (userData: { email: string; name: string; username: string; id: string }) => {
    login(userData)
    setShowLogin(false)
    // Redirect to community page after login
    navigate('/community')
  }

  const galleryVideos = [
    {
      id: '1',
      title: 'sonic pi sessions',
      tags: ['live coding', 'ambient'],
      libraryPath: '/library/sonic-pi',
      webmSrc: '/videos/sonic-pi-sessions.webm',
      mp4Src: '/videos/sonic-pi-sessions.mp4',
      soundcloudUrl: 'https://soundcloud.com/nessakodo',
      twitchUrl: 'https://twitch.tv/nessakodo',
      youtubeUrl: 'https://youtube.com/@nessakodo',
    },
    {
      id: '2',
      title: 'strudel notebooks',
      tags: ['algorithmic', 'web audio'],
      libraryPath: '/library/strudel',
      webmSrc: '/videos/strudel-notebooks.webm',
      mp4Src: '/videos/strudel-notebooks.mp4',
      soundcloudUrl: 'https://soundcloud.com/nessakodo',
      twitchUrl: 'https://twitch.tv/nessakodo',
      youtubeUrl: 'https://youtube.com/@nessakodo',
    },
    {
      id: '3',
      title: 'playtronica mappings',
      tags: ['interactive', 'hardware'],
      libraryPath: '/library/playtronica',
      webmSrc: '/videos/playtronica-mappings.webm',
      mp4Src: '/videos/playtronica-mappings.mp4',
      soundcloudUrl: 'https://soundcloud.com/nessakodo',
      twitchUrl: 'https://twitch.tv/nessakodo',
      youtubeUrl: 'https://youtube.com/@nessakodo',
    },
    {
      id: '4',
      title: 'patch diagrams',
      tags: ['visual', 'generative'],
      libraryPath: '/library/patches',
      webmSrc: '/videos/patch-diagrams.webm',
      mp4Src: '/videos/patch-diagrams.mp4',
      soundcloudUrl: 'https://soundcloud.com/nessakodo',
      twitchUrl: 'https://twitch.tv/nessakodo',
      youtubeUrl: 'https://youtube.com/@nessakodo',
    },
  ]

  return (
    <main className="main-content home-page">
      {/* Full-screen Hero Section */}
      <section className="home-hero">
        <AsciiMeshV2 />
        <div className="hero-content">
            <div className="hero-main centered-hero-text">
              <h1 className="hero-name">sound, code, and living systems.</h1>
              <p className="hero-subtitle">where patterns become rhythm and story</p>
              <button
                className="hero-scroll-indicator"
                onClick={() => document.getElementById('email-section')?.scrollIntoView({ behavior: 'smooth' })}
                aria-label="Scroll to sign up section"
              >
                <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1 L9 9 L17 1" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
      </section>

      {/* Email/Auth Section */}
      <EmailAuthSection />

      {/* Video Gallery Section - Full Screen Height */}
      <section className="video-gallery-section">
        <VideoGallery videos={galleryVideos} />
      </section>

      {/* Patreon CTA */}
      <section className="home-section patreon-section">
        <PatreonCTA />
      </section>

      <LoginModal isOpen={showLogin} onClose={() => setShowLogin(false)} onLoginSuccess={handleLoginSuccess} />
    </main>
  )
}

export default Home
